export const COURSE_ENTRY_REASONS = {
    UNPAID: 'unpaid',
    ACCOUNT_LIMIT: 'account_limit',
};

export const isStudentCourseEntryPaid = (user) => {
    if (user?.typeUser !== 'estudiante') return true;
    return user?.statusSubscription === 'pagado';
};
